import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { NotificationSurveyCommentDto } from './dtos/notification-survey-comment.dto';
import { NotificationSurveyCommentMapper } from './mappers/notification-survey-comment.mapper';
import { NotificationActionLiveState } from '../state/notification.model';

// Stopgap until PD-18317 serves live action state; untagged, a background read.
@Injectable({ providedIn: 'root' })
export class NotificationSurveyCommentApi {
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _httpClient = inject(HttpClient);
  private readonly _mapper = new NotificationSurveyCommentMapper();

  public actionLiveStates(
    surveyId: string,
  ): Observable<NotificationActionLiveState[]> {
    return this._httpClient
      .get<
        NotificationSurveyCommentDto[]
      >(`${this._environmentConfig.pureSpectrum.url}/surveys/${surveyId}/comments`)
      .pipe(map((commentDtos) => this._mapper.fromDtoList(commentDtos).flat()));
  }
}
